import { createContext } from "react";

export type AuthenticationContent = {
  isLoggedIn: boolean,
  isAuthenticationReady: boolean,
};

export const AuthenticationContext = createContext<AuthenticationContent>({
  isLoggedIn: false,
  isAuthenticationReady: false,
});
